module.exports = __webpack_public_path__ + "img/unsign_invoice.14741bb1.svg";